export default "__VITE_ASSET__927fd27e__"